import JwtAxios from "../../apiServices";
import {
  PACKING_REPORT_TEMPLATE_PRE_REQUISITES,
  PACKING_REPORT_TEMPLATE_VARIABLE_DATA,
} from "../../apiServices/API_ENDPOINTS";
import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  GET_PACKING_REPORT_TEMPLATE_PRE_DATA,
  GET_PACKING_REPORT_TEMPLATE_VARIABLE_DATA,
} from "../ActionTypes";

export const onGetPackingReportTemplatePreData = (page = 1, per_page = 25, name = "") => {
  return async (dispatch) => {
    dispatch({ type: FETCH_START });
    try {
      const response = await JwtAxios.get(PACKING_REPORT_TEMPLATE_PRE_REQUISITES, {
        // params: { page, per_page, name },
      });

      if (response?.status === 200) {
        const payload = response.data?.data || {};
        dispatch({
          type: GET_PACKING_REPORT_TEMPLATE_PRE_DATA,
          payload,
        });
        dispatch({ type: FETCH_SUCCESS });
        return payload;
      } else {
        const msg = response?.data?.message || "Something went wrong!";
        dispatch({ type: FETCH_ERROR, payload: msg });
        throw new Error(msg);
      }
    } catch (error) {
      const errMsg = error?.message || "Network error";
      dispatch({ type: FETCH_ERROR, payload: errMsg });
      throw error;
    }
  };
};

export const onGetPackingReportTemplateVariableData = ({ slug = "" }) => {
  return async (dispatch) => {
    // dispatch({ type: FETCH_START });
    try {
      const response = await JwtAxios.get(`${PACKING_REPORT_TEMPLATE_VARIABLE_DATA}/${slug}`);

      if (response?.status === 200) {
        const payload = response.data?.data || {};
        dispatch({
          type: GET_PACKING_REPORT_TEMPLATE_VARIABLE_DATA,
          payload,
        });
        dispatch({ type: FETCH_SUCCESS });
        return payload;
      } else {
        const msg = response?.data?.message || "Something went wrong!";
        dispatch({ type: FETCH_ERROR, payload: msg });
        throw new Error(msg);
      }
    } catch (error) {
      const errMsg = error?.message || "Network error";
      dispatch({ type: FETCH_ERROR, payload: errMsg });
      throw error;
    }
  };
};

// export const onGetBankDetails = (bankId) => {

//     return (dispatch) => {
//         dispatch({type: FETCH_START});
//         JwtAxios
//             .get(`api/banks/${bankId}/edit`)

//             .then((data) => {
//                 if (data.status === 200) {
//                     dispatch({type: FETCH_SUCCESS});
//                     dispatch({type: GET_BANK_DETAIL, payload: data.data});
//                     dispatch({
//                         type: SHOW_MESSAGE,
//                         payload: "Bank Updated Successfully",
//                     });
//                     // HandleNotification('success', 'bottomRight', 'Bank Account updated Successfully!', null)
//                 } else {
//                     dispatch({
//                         type: FETCH_ERROR,
//                         payload: "Something went wrong!",
//                     });
//                     // HandleNotification('success', 'bottomRight', 'Something went wrong!', null)
//                 }
//             })
//             .catch((error) => {
//                 dispatch({type: FETCH_ERROR, payload: error.message});
//             });
//     };
// };

// export const onCreateBank = (bank) => {
//     return (dispatch) => {
//         dispatch({type: FETCH_START});
//         JwtAxios
//             .post(`${CREATE_BANK_ENDPOINT}`, bank)
//             .then((data) => {
//                 if (data.status === 200) {
//                     dispatch({type: FETCH_SUCCESS});
//                     dispatch({type: CREATE_NEW_BANK, payload: data.data});
//                     dispatch({
//                         type: SHOW_MESSAGE,
//                         payload: "Bank Created Successfully",
//                     });
//                     HandleNotification('success', 'bottomRight', 'bank Created Successfully!', null)
//                 } else {
//                     dispatch({
//                         type: FETCH_ERROR,
//                         payload: "Something went wrong!",
//                     });
//                     HandleNotification('error', 'bottomRight', 'Something went wrong!', null)

//                 }
//             })
//             .catch((error) => {
//
//                 dispatch({type: FETCH_ERROR, payload: error.message});
//             });
//     };
// };

// export const onUpdateSelectedBank = (bank) => {
//     return (dispatch) => {
//         dispatch({type: FETCH_START});
//         JwtAxios
//             .put(`${EDIT_BANK_ENDPOINT}/${bank.id}`, bank)

//             .then((data) => {
//                 if (data.status === 200) {
//                     dispatch({type: FETCH_SUCCESS});
//                     dispatch({type: UPDATE_BANK_DETAIL, payload: data.data});
//                     dispatch({
//                         type: SHOW_MESSAGE,
//                         payload: "bank Updated Successfully",
//                     });
//                     HandleNotification('success', 'bottomRight', 'bank updated Successfully!', null)
//                 } else {
//                     dispatch({
//                         type: FETCH_ERROR,
//                         payload: "Something went wrong!",
//                     });
//                     HandleNotification('success', 'bottomRight', 'Something went wrong!', null)
//                 }
//             })
//             .catch((error) => {
//                 dispatch({type: FETCH_ERROR, payload: error.message});
//             });
//     };
// };

// export const onDeleteBank = (bank) => {
//     return (dispatch) => {
//         dispatch({type: FETCH_START});
//         JwtAxios
//             .delete(`${DELETE_BANK_ENDPOINT}/${bank['id']}`)
//             .then((data) => {
//                 if (data.status === 200) {
//                     dispatch({type: FETCH_SUCCESS});
//                     dispatch({type: DELETE_BANK, payload: data.data});
//                     dispatch({
//                         type: SHOW_MESSAGE,
//                         payload: "Deleted bank Successfully",
//                     });

//                     HandleNotification('success', 'bottomRight', 'bank deleted Successfully!', null)
//                 } else {
//                     dispatch({
//                         type: FETCH_ERROR,
//                         payload: "Something went wrong!",
//                     });
//                     HandleNotification('error', 'bottomRight', 'Something went wrong!', null)
//                 }
//             })
//             .catch((error) => {
//                 dispatch({type: FETCH_ERROR, payload: error.message});
//             });
//     };
// };

// export const onCreateBranch = (branch) => {
//     return (dispatch) => {
//         dispatch({type: FETCH_START});
//         JwtAxios
//             .post(`${CREATE_BRANCH_ENDPOINT}`, branch)
//             .then((data) => {
//                 if (data?.data?.code === 200) {
//                     dispatch({type: FETCH_SUCCESS});
//                     dispatch({type: CREATE_NEW_BRANCH, payload: data.data});
//                     dispatch({
//                         type: SHOW_MESSAGE,
//                         payload: "Bank Created Successfully",
//                     });
//                     HandleNotification('success', 'bottomRight', 'Branch Created Successfully!', null)
//                 } else {
//                     dispatch({
//                         type: FETCH_ERROR,
//                         payload: "Something went wrong!",
//                     });
//                     HandleNotification('error', 'bottomRight', 'Something went wrong!', null)

//                 }
//             })
//             .catch((error) => {
//
//                 dispatch({type: FETCH_ERROR, payload: error.message});
//                 HandleNotification('error', 'bottomRight', 'Something went wrong!', null)

//             });
//     };
// };
